import React from "react";
import { useCookieConsentContext } from "@use-cookie-consent/react";
import { FC, useState } from "react";
import './styles.css';
import { backgrounds } from "src/assets";
import HoveredButton from "../HoveredButton";
import cookiesBg from "../../assets/images/backgrounds/Cookie_popup_bg.webp";
import MediaQuery from "react-responsive";

const CookiesBanner: FC = () => {
  const { declineAllCookies, acceptCookies, consent } =
    useCookieConsentContext();

  const [showBanner, setShowBanner] = useState(true);


  return !showBanner ? (
    <></>
  ) : (
    consent.firstParty ? <></> :
    <>
      <MediaQuery minWidth={1224}>
        <div className="overlay">
          <div className="cookie-pop">
            <div className="pop-c">
              <img src={cookiesBg} id='cookie-pop-img' />
              <div id='cookie-text'>
                <h1>We use cookies</h1>
                <p>
                  This website uses cookies to ensure <br />
                  you get the best experience. <br />
                  Would you accept our{" "}
                  <a href="/cookies-policy" target="_blank" rel="noreferrer">
                    {" "}
                    Cookies Policy
                  </a>
                  ?
                </p>
                <div>
                  <HoveredButton
                    bg={backgrounds.buttons.accept_btn}
                    hover={backgrounds.buttons.accept_hover}
                    style={{ width: "150px", height: "40px" }}
                    onClick={() => acceptCookies({ firstParty: true })}
                  />
                  <HoveredButton
                    bg={backgrounds.buttons.decline_btn}
                    hover={backgrounds.buttons.decline_hover}
                    style={{ width: "150px", height: "40px" }}
                    onClick={() => {
                      declineAllCookies();
                      setShowBanner(false);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </MediaQuery>
      <MediaQuery maxWidth={1223}>
        <div id="mobile-popup-container">
          <img src={cookiesBg} id='cookie-pop-img' />
          <div id='cookie-text'>
            <h1>We use cookies</h1>
            <p>
              This website uses cookies to ensure <br />
              you get the best experience. <br />
              Would you accept our{" "}
              <a href="/cookies-policy" target="_blank" rel="noreferrer">
                {" "}
                Cookies Policy
              </a>
              ?
            </p>
            <div>
              <HoveredButton
                bg={backgrounds.buttons.accept_btn}
                hover={backgrounds.buttons.accept_hover}
                style={{ width: "150px", height: "40px" }}
                onClick={() => acceptCookies({ firstParty: true })}
              />
              <HoveredButton
                bg={backgrounds.buttons.decline_btn}
                hover={backgrounds.buttons.decline_hover}
                style={{ width: "150px", height: "40px" }}
                onClick={() => {
                  declineAllCookies();
                  setShowBanner(false);
                }}
              />
            </div>
          </div>
        </div>
      </MediaQuery>
    </>
  );
};

export default CookiesBanner;
